import { DocumentsTabWithPreAccess } from "../../../../shared/projects/project/documents";

const Documents = (): JSX.Element => (
  <DocumentsTabWithPreAccess
    descriptionText="Manage project files, upload new versions, and review document history from this workspace."
    type="seed"
  />
);

export default Documents;
